import React, {useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {useHistory, useParams} from 'react-router-dom';

import {resetPassword, checkResetToken} from 'actions/userActions';

import validationHelper from 'helpers/validationHelper';
import uiHelper from 'helpers/uiHelper';

import TextInput from 'components/common/TextInput';
import AuthContainer from './components/AuthContainer';
import AuthBackgroundImage from './components/AuthBackgroundImage';
import AuthBodyContainer from './components/AuthBodyContainer';
import AuthTitle from './components/AuthTitle';
import AuthLink from './components/AuthLink';
import SubmitButton from './components/SubmitButton';

interface ParamTypes {
  token: string;
}

function PasswordResetPage() {
  const dispatch = useDispatch();

  let history = useHistory();

  let {token} = useParams<ParamTypes>();

  const [userData, setUserData] = useState({password: '', confirmPassword: '', token: ''});
  const [errors, setErrors] = useState({password: '', confirmPassword: ''});

  useEffect(() => {
    onCheckResetToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function onCheckResetToken() {
    await dispatch(checkResetToken(token));

    setUserData({token, password: '', confirmPassword: ''});
  }

  function onChange(field: string, value) {
    setUserData({...userData, [field]: value});
  }

  function resetFormIsValid() {
    let newErrors = {password: '', confirmPassword: ''};

    if (!userData.password) {
      newErrors.password = 'Password field is required.';
    }

    if (!userData.confirmPassword) {
      newErrors.confirmPassword = 'Please confirm the password.';
    }

    if (userData.password && userData.confirmPassword && userData.password !== userData.confirmPassword) {
      newErrors.confirmPassword = 'Wrong password.';
    }

    setErrors(newErrors);

    return validationHelper.isEmptyErrorObject(newErrors);
  }

  async function onResetPassword(e) {
    if (e) e.preventDefault();

    if (!isActiveButton()) return;

    if (!resetFormIsValid()) return;

    await dispatch(resetPassword(userData));

    uiHelper.showMessage('Password has been changed');

    history.push('/login');
  }

  function isActiveButton() {
    return userData.password && userData.confirmPassword ? true : false;
  }

  function render() {
    let isActive = isActiveButton();

    return (
      <AuthContainer>
        <AuthBackgroundImage />

        <AuthBodyContainer isSignUp={false}>
          <AuthTitle>Reset Password</AuthTitle>

          <form>
            <TextInput
              name="password"
              type="password"
              value={userData.password}
              onChange={onChange}
              placeholder="New password"
              error={errors.password}
            />

            <TextInput
              name="confirmPassword"
              type="password"
              value={userData.confirmPassword}
              onChange={onChange}
              placeholder="Confirm password"
              error={errors.confirmPassword}
            />

            <SubmitButton isActive={isActive} title="Save Password" onSubmit={onResetPassword} />
          </form>
          <AuthLink url="/login" title="Already have an account?" linkText="Login" />
        </AuthBodyContainer>
      </AuthContainer>
    );
  }

  return render();
}

export default PasswordResetPage;
